import { render, staticRenderFns } from "./EditWishActivityDailyRewardDialog.vue?vue&type=template&id=256e157b&scoped=true"
import script from "./EditWishActivityDailyRewardDialog.vue?vue&type=script&lang=js"
export * from "./EditWishActivityDailyRewardDialog.vue?vue&type=script&lang=js"
import style0 from "./EditWishActivityDailyRewardDialog.vue?vue&type=style&index=0&id=256e157b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e157b",
  null
  
)

export default component.exports